// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./types.d.ts" />

import { useCallback } from 'react';
import { env } from 'settings/env';

type WidgetOptions = {
  paymentAmount: number;
};

type CheckoutOptions = {
  paymentAmount: number;
  placeholderId: string;
};

type ReturnHook = {
  showOneyWidget: (options: WidgetOptions) => void;
  showOneyWidgetCheckout: (options: CheckoutOptions) => void;
};

export default function useOneyWidget(): ReturnHook {
  const country = env.ENV_COUNTRY === 'uk' ? 'GB' : env.ENV_COUNTRY;
  const language = env.ENV_PAGE_LANGUAGE;
  const merchantGuid = env.ENV_ONEY_MERCHANT_GUID;

  const showOneyWidget = useCallback((options: WidgetOptions) => {
    if (typeof window['loadOneyWidget'] === 'function') {
      window.loadOneyWidget(() => {
        const fnName =
          options.paymentAmount >= 100
            ? 'loadSimulationPopin'
            : 'loadPedagogicPopin';

        window.oneyMerchantApp?.[fnName]({
          options: {
            country: country.toUpperCase(),
            language: language.toUpperCase(),
            merchant_guid: merchantGuid,
            filter_by: 'filters',
            filters: [
              { is_free: true, payment_mode: '3x', with_down_payment: true },
            ],
            payment_amount:
              options.paymentAmount >= 100 && options.paymentAmount <= 6000
                ? options.paymentAmount
                : 100,
          },
        });
      });
    }
  }, []);

  const showOneyWidgetCheckout = useCallback((options: CheckoutOptions) => {
    if (typeof window['loadOneyWidget'] === 'function') {
      window.loadOneyWidget(() => {
        window.oneyMerchantApp?.loadCheckoutSection({
          options: {
            country: country.toUpperCase(),
            language: language.toUpperCase(),
            merchant_guid: merchantGuid,
            filter_by: 'filters',
            filters: [
              { is_free: true, payment_mode: '3x', with_down_payment: true },
            ],
            payment_amount: options.paymentAmount,
            checkout_placeholder: options.placeholderId,
          },
        });
      });
    }
  }, []);

  return {
    showOneyWidget,
    showOneyWidgetCheckout,
  };
}
